<template>
  <div class="material-rating">
    <div class="d-flex justify-content-start align-items-center">
      <div class="mr-3">{{$t('materialStats.articleRating')}}</div>
      <div class="d-inline-block">
        <div class="d-flex material-rating__icons" :class="{'rate-blocked': rateSendingDisabled}">
          <div v-for="rate in 5" :key="rate" @click="!rateSending && !rateSendingDisabled ? rateMaterial(rate) : false"
              class="star-icon-holder"
              :class="{'rated': (scaledRating >= rate) && !rateSendingDisabled, 'rated-by-user': userRating >= rate}">
            <StarIcon />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StarIcon from '@/components/StarIcon.vue';

export default {
  components: {
    StarIcon,
  },
  props: {
    materialId: null,
    rating: null,
  },
  data() {
    return {
      scaledRating: null,
      rateSending: false,
      rateSendingSuccess: false,
      rateSendingDisabled: false,
      userRatings: [],
      userRating: null,
    };
  },
  created() {
    this.userRatings = JSON.parse(localStorage.getItem('ratings') || '[]');
    this.userRatings.forEach((rate) => {
      if (rate.materialId === this.materialId) {
        this.rateSendingDisabled = true;
        this.userRating = rate.rate;
      }
    });
  },
  mounted() {
    this.scaledRating = Math.round(this.rating);
  },
  methods: {
    rateMaterial(rate) {
      this.rateSending = true;
      this.rateError = '';
      this.userRating = rate;
      this.scaledRating = null;
      this.$http.post(`${process.env.VUE_APP_API_SUPPORT_URL}/page_rate`, { rate, material_id: this.materialId }).then(() => {
        this.rateSending = false;
        this.rateSendingSuccess = true;
        this.rateSendingDisabled = true;
        this.userRatings.push({ materialId: this.materialId, rate });
        this.showSuccessMessage();
        localStorage.setItem('ratings', JSON.stringify(this.userRatings));
      }).catch(() => {
        this.rateSending = false;
        this.userRating = null;
        this.scaledRating = Math.round(this.rating);
        this.showErrorMessage();
      });
    },
    showSuccessMessage() {
      this.$bvToast.toast('Success', {
        title: this.$t('materialStats.ratingSuccess'),
        variant: 'light',
        solid: true,
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-center',
        bodyClass: 'd-none',
        toastClass: 'toast-secondary',
      });
    },
    showErrorMessage() {
      this.$bvToast.toast('Error', {
        title: this.$t('common.connectionError'),
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-center',
        bodyClass: 'd-none',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.material-rating {
  &__icons {
    .star-icon-holder {
      &.rated {
        ::v-deep svg {
          fill: lighten($color: #ffc309, $amount: 30);
        }
      }
      &.rated-by-user {
        ::v-deep svg {
          fill:  #ffc309;
        }
      }
    }
  }
  &__icons:not(.rate-blocked) {
    cursor: pointer;
    &:hover .star-icon-holder ::v-deep svg {
      fill: #ffc309;
    }
    .star-icon-holder:hover,
    .star-icon-holder:hover ~ .star-icon-holder {
      &::v-deep svg {
        fill: #ffc309;
      }
      ~ .star-icon-holder {
        &::v-deep svg {
          fill: transparent;
        }
      }
    }
  }
}
</style>
